// extracted by mini-css-extract-plugin
module.exports = {"card":"ToolCard_card__OjR6z","icon":"ToolCard_icon__2vVDt","heading":"ToolCard_heading__fEp5V","description":"ToolCard_description__YSkTE"};